module.exports = __webpack_public_path__ + "static/media/google-cloud.42efc4f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/google-cloud.png
// module id = 15
// module chunks = 0